module.exports = __webpack_public_path__ + "static/media/logomewah4.ce5df3d4.png";